import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';
import { CirclePicker } from 'react-color';
import { If, Then } from 'react-if'

import DeckGL from "deck.gl";
import {WebMercatorViewport, FlyToInterpolator} from 'deck.gl';
import {GeoJsonLayer, IconLayer, TextLayer} from 'deck.gl'
import { _MapContext as MapContext, StaticMap, Marker, NavigationControl } from "react-map-gl";
import { EditableGeoJsonLayer, DrawPolygonMode, ExtrudeMode, ModifyMode, ScaleMode, TranslateMode, CompositeMode, TransformMode, ScatterplotLayer } from "nebula.gl";
// import { Editor, EditingMode, DrawLineStringMode, DrawPolygonMode } from "react-map-gl-draw";

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import Geocoder from 'composer/views/content/Geocoder.jsx'

import { Grid, TextField, FormControl, Select, MenuItem, FormHelperText, Icon, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Card, CardContent } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import FilePicker from "composer/views/FilePicker.jsx";
import LocaleDetailMapBar from "composer/views/locale/LocaleDetailMapBar.jsx"

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Rectangle,
} from "react-google-maps";
import view from '@deck.gl/core/dist/es5/views/view';

const MinLocaleMapSize = 1000;
const MaxLocaleMapSize = 6000;
var oneMB = 1024 * 1024;

class LocaleDetailView extends React.Component {
  MinLocaleMapSize() {
    return MinLocaleMapSize;
  }
  MaxLocaleMapSize() {
    return MaxLocaleMapSize;
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();
    this.mapRef = React.createRef();

    this.updateMapZoom = this.updateMapZoom.bind(this);

    // state variables here
    this.state = {
      isDirty: false,
      activeView: 0,
      localeName: "",
      localeDesc: "",
      localeKLA: -1,
      localeSubject: -1,
      localeCoverFileID: "",
      localeColor: this.props.theme.palette.primary.main.substring(1),
      localeShareable: false,
      localeLanguage: "tc",
      localePublish: false,
      hsRevealCode: "",
      hsRevealCodeEnabled: false,
      map: {
        center: {
          lat: 0,
          lon: 0
        },
        bounds:{
          ul:{
            lat: 0,
            lon: 0
          },
          br:{
            lat: 0,
            lon: 0
          }
        },
        screenCoordinates:{
          ul:{
            x: 0,
            y: 0
          },
          br:{
            x: 0,
            y: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      },
      localeCenter: {
        lat: 22.4191,
        lng: 114.2059,
      },
      localeUpperLeft: {
        lat: 22.4299,
        lng: 114.1942,
      },
      localeBottomRight: {
        lat: 22.4083,
        lng: 114.2176,
      },
      boxData: {
        type: "FeatureCollection",
        features:[{
          type: "Feature",
          color: this.props.theme.palette.primary.main,
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [114.2176, 22.4083],
                [114.2176, 22.4299],
                [114.1942, 22.4299],
                [114.1942, 22.4083],
                [114.2176, 22.4083]
              ]
            ]
          }
        }]
      },
      localeRect: {
        bounds:{
          ul:{
            lat: 22.4299,
            lon: 114.1942,
          },
          br:{
            lat: 22.4083,
            lon: 114.2176,
          },
          center:{
            lat: 22.4191,
            lon: 114.2059
          }
        }
      },
      viewState:{
        latitude: 22.4191,
        longitude: 114.2059,
        zoom: 15,
        bearing: 0,
        pitch: 0,
        width: 500,
        height: 500
      },
      zoom: 15,
      localeBoundaryRect: null,
      localeCoverFilePath: "",
      localeCoverPreviewPath: "",
      translateModeContainer: new TranslateMode(),
      extrudeModeContainer: new ExtrudeMode(),
      modifyModeContainer: new ModifyMode(),
      transformModeContainer: new TransformMode(),
      flyContainer: new FlyToInterpolator({speed: 2})
    };
    autoBind(this);

    let currentLocale = this.props.root.getCurrentLocale();
    if (currentLocale) {
      console.log("current locale:", currentLocale);
      this.state.localeName = currentLocale.name;
      this.state.localeDesc = currentLocale.description;
      this.state.localeKLA = parseInt(currentLocale.kla);
      this.state.localeSubject = parseInt(currentLocale.subject);
      this.state.localeCoverFileID = currentLocale.tn_file_id;
      this.state.localeColor = parseInt(currentLocale.color).toString(16).padStart(6, '0');
      this.state.localeShareable = parseInt(currentLocale.is_share) > 0;
      this.state.localeLanguage = currentLocale.lang;
      this.state.localePublish = parseInt(currentLocale.is_ready) > 0;
      this.state.hsRevealCode = currentLocale.hs_reveal_code;
      this.state.hsRevealCodeEnabled = parseInt(currentLocale.hs_reveal_code_enabled) > 0;
      this.state.localeCenter = {lat: parseFloat(currentLocale.mid_lat), lng: parseFloat(currentLocale.mid_lon)};
      this.state.localeUpperLeft = {lat: parseFloat(currentLocale.ul_lat), lng: parseFloat(currentLocale.ul_lon)};
      this.state.localeBottomRight = {lat: parseFloat(currentLocale.br_lat), lng: parseFloat(currentLocale.br_lon)};
      // CHANGE before deployment
      this.state.localeCoverFilePath = Config.UPLOAD_PATH() + currentLocale.path;
      this.state.localeCoverPreviewPath = Config.UPLOAD_PATH() + currentLocale.tn_path;
      this.state.viewState = {
        latitude: parseFloat(currentLocale.mid_lat),
        longitude: parseFloat(currentLocale.mid_lon),
        zoom: 15,
        bearing: 0,
        pitch: 0,
        width: 500,
        height: 500,
        maxZoom: 17,
        minZoom: 3
      };
      this.state.map = {
        zoom: 0,
        center: {
          lat: this.state.localeCenter.lat,
          lon: this.state.localeCenter.lng
        },
        bounds:{
          ul:{
            lat: this.state.localeUpperLeft.lat,
            lon: this.state.localeUpperLeft.lng
          },
          br:{
            lat: this.state.localeBottomRight.lat,
            lon: this.state.localeBottomRight.lng
          }
        },
        screenCoordinates:{
          ul:{
            x: 0,
            y: 0
          },
          br:{
            x: 0,
            y: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      };
      this.state.boxData = {
        type: "FeatureCollection",
        features:[{
          type: "Feature",
          color: this.state.localeColor,
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [this.state.localeBottomRight.lng, this.state.localeBottomRight.lat],
                [this.state.localeBottomRight.lng, this.state.localeUpperLeft.lat],
                [this.state.localeUpperLeft.lng, this.state.localeUpperLeft.lat],
                [this.state.localeUpperLeft.lng, this.state.localeBottomRight.lat],
                [this.state.localeBottomRight.lng, this.state.localeBottomRight.lat]
              ]
            ]
          }
        }]
      };
      this.state.localeRect = {
        bounds:{
          ul:{
            lat: this.state.localeUpperLeft.lat,
            lon: this.state.localeUpperLeft.lng
          },
          br:{
            lat: this.state.localeBottomRight.lat,
            lon: this.state.localeBottomRight.lng
          },
          center:{
            lat: this.state.localeCenter.lat,
            lon: this.state.localeCenter.lng
          }
        }
      };
    }

    if (this.props.activeView) {
      this.state.activeView = this.props.activeView;
    }

    if (this.props.parent.state.title != null) {
      this.props.parent.setState({ title: this.state.localeName });
    }
  }

  changeActiveView(index) {
    this.setState({ activeView: index });
    this.state.activeView = index;
  }

  checkDirty(oldValue, newValue) {
    let dirty = (oldValue != newValue);
    this.setState({ isDirty: dirty });
    this.state.isDirty = dirty;
  }

  localeNameChanged(e) {
    this.setState({
      localeName: e.target.value
    });
    this.state.localeName = e.target.value;

    if (this.props.root.getCurrentLocale()) {
      this.checkDirty(this.props.root.getCurrentLocale().name, e.target.value);
    }

    if (this.props.parent.state.title != null) {
      this.props.parent.setState({ title: this.state.localeName });
    }
  }

  localeDescChanged(e) {
    this.setState({
      localeDesc: e.target.value
    })
    this.state.localeDesc = e.target.value;

    if (this.props.root.getCurrentLocale()) {
      this.checkDirty(this.props.root.getCurrentLocale().description, e.target.value);
    }
  }

  localeKLAChanged(e) {
    this.setState({localeKLA: e.target.value});
    this.state.localeKLA = e.target.value;

    this.setState({ localeSubject: 0 });
    this.state.localeSubject = 0;

    if (this.props.root.getCurrentLocale()) {
      this.checkDirty(this.props.root.getCurrentLocale().kla, e.target.value);
    }
  }

  localeSubjectChanged(e) {
    this.setState({localeSubject: e.target.value});
    this.state.localeSubject = e.target.value;

    if (this.props.root.getCurrentLocale()) {
      this.checkDirty(this.props.root.getCurrentLocale().subject, e.target.value);
    }
  }

  localeColorChanged(color, event) {
    this.updateMapState();

    this.setState({localeColor: color.hex.substring(1)});
    this.state.localeColor = color.hex.substring(1);
  }

  localeLanguageChanged(e) {
    this.setState({localeLanguage: e.target.value});
    this.state.localeLanguage = e.target.value;
  }

  localeShareableChanged(e) {
    this.setState({localeShareable: e.target.value});
    this.state.localeShareable = e.target.value;
  }

  localePublishChanged(e) {
    this.setState({localePublish: e.target.value});
    this.state.localePublish = e.target.value;
  }

  enableRevealCodeChanged(e) {
    this.setState({hsRevealCodeEnabled: e.target.value});
    this.state.hsRevealCodeEnabled = e.target.value;
  }

  revealCodeChanged(e) {
    this.setState({
      hsRevealCode: e.target.value
    })
    this.state.hsRevealCode = e.target.value;

    if (this.props.root.getCurrentLocale()) {
      this.checkDirty(this.props.root.getCurrentLocale().hs_reveal_code, e.target.value);
    }
  }

  validateRevealCode(){
    let result = true;
    let code = this.state.hsRevealCode.trim();
    let illegalChars = /[\W_]/;
    let errorMessage = "";

    if (code == "") {
      result = false;
      errorMessage = Localization.strings.REVEAL_CODE_REQUIREMENT_3;
    }
    else if (illegalChars.test(code)) {
      result = false;
      errorMessage = Localization.strings.REVEAL_CODE_REQUIREMENT_0;
    }
    else if (code.search(/[a-zA-Z]+/) == -1 || code.search(/[0-9]+/) == -1) {
      result = false
      errorMessage = Localization.strings.REVEAL_CODE_REQUIREMENT_1;
    }
    else if (code.length != 6) {
      result = false;
      errorMessage = Localization.strings.REVEAL_CODE_REQUIREMENT_2;
    }

    return errorMessage;
  }

  validateInput() {
    let isValid = true;
    let errorMessage = "";
    switch (this.state.activeView) {
      case 0:
        let name = this.state.localeName.trim();
        this.setState({ localeName: name });
        this.state.localeName = name;
        if (name == "") {
          isValid = false;
          errorMessage = Localization.strings.LOCALE_NAME_BLANK_REMINDER;
        }
        else if (this.state.localeKLA < 0) {
          isValid = false;
          errorMessage = Localization.strings.LOCALE_KLA_BLANK_REMINDER;
        }
        else if (this.state.localeSubject < 0) {
          isValid = false;
          errorMessage = Localization.strings.LOCALE_SUBJECT_BLANK_REMINDER;
        }
        break;
      case 1:
        if (this.state.localeCoverFileID == "") {
          isValid = false;
          errorMessage = Localization.strings.LOCALE_COVER_BLANK_REMINDER;
        }
        break;
      case 2:
        let result = this.checkLocaleBoundary();
        isValid = (result == 0);
        if (isValid) {
          this.updateMapState();
        }
        if (result < 0) {
          errorMessage = Localization.strings.LOCALE_MAP_MIN_SIZE_REMINDER;
        }
        else if (result > 0) {
          errorMessage = Localization.strings.LOCALE_MAP_MAX_SIZE_REMINDER;
        }
        break;
      case 3:
        // validate reveal code if reveal code is enabled
        if(this.state.hsRevealCodeEnabled){
          errorMessage = this.validateRevealCode();
          if(errorMessage != ""){
            isValid = false;
          }
        }
        break;
      default:
        break;
    }

    if (errorMessage != "") {
      // console.log('here');
      this.props.root.addNotification(errorMessage, false);
    }

    return isValid;
  }

  onUploadSuccess(res) {
    console.log("upload success: " + res['file_id']);
    let fileID = res['file_id'];
    this.setState({ localeCoverFileID: fileID });
    this.state.localeCoverFileID = fileID;
  }

  onAbortUpload() {
    this.setState({ localeCoverFileID: "" });
    this.state.localeCoverFileID = "";
  }

  onMapMounted = (map) => {
    this.state.map = map;
  }

  onRectangleMounted(){
    if (this.refs.localeDetailMapBar) {
      this.refs.localeDetailMapBar.updateMapSize();
    }
  }

  onBoundsChanged() {
    if (this.props.parent.onBoundsChanged) {
      this.props.parent.onBoundsChanged();
    }
    if (this.refs.localeDetailMapBar) {
      this.refs.localeDetailMapBar.updateMapSize();
    }
  }

  localeMatchViewClicked() {
    this.updateMapState();

    let bounds = this.state.map.bounds;
    let upperLeftLatLon = {
      lat: bounds.ul.lat,
      lng: bounds.ul.lon,
    };
    let bottomRightLatLon = {
      lat: bounds.br.lat,
      lng: bounds.br.lon,
    }
    let upperLeftInMeter = this.latLonToMeter(upperLeftLatLon.lat, upperLeftLatLon.lng);
    let bottomRightInMeter = this.latLonToMeter(bottomRightLatLon.lat, bottomRightLatLon.lng);
    let heightBorder = (upperLeftInMeter.y - bottomRightInMeter.y) * 0.1;
    upperLeftInMeter.y -= heightBorder;
    bottomRightInMeter.y += heightBorder;
    let centerInMeterX = (upperLeftInMeter.x + bottomRightInMeter.x) / 2.0;
    let centerInMeterY = (upperLeftInMeter.y + bottomRightInMeter.y) / 2.0;
    let width = upperLeftInMeter.y - bottomRightInMeter.y;
    upperLeftInMeter.x = centerInMeterX - width / 2.0;
    bottomRightInMeter.x = centerInMeterX + width / 2.0;

    upperLeftLatLon = this.meterToLatLon(upperLeftInMeter.x, upperLeftInMeter.y);
    bottomRightLatLon = this.meterToLatLon(bottomRightInMeter.x, bottomRightInMeter.y);
    let upperLeft = {
      lat: upperLeftLatLon.lat,
      lng: upperLeftLatLon.lon,
    };
    let bottomRight = {
      lat: bottomRightLatLon.lat,
      lng: bottomRightLatLon.lon,
    };

    let centerLatLon = this.meterToLatLon(centerInMeterX, centerInMeterY);
    let center = {
      lat: centerLatLon.lat,
      lng: centerLatLon.lon,
    };

    this.setState({
      localeCenter: center,
      localeUpperLeft: upperLeft,
      localeBottomRight: bottomRight,
    });
    this.state.localeCenter = center;
    this.state.localeUpperLeft = upperLeft;
    this.state.localeBottomRight = bottomRight;
    // change also boxdata
    this.state.boxData = {
      type: "FeatureCollection",
      features:[{
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [this.state.localeBottomRight.lng, this.state.localeBottomRight.lat],
              [this.state.localeBottomRight.lng, this.state.localeUpperLeft.lat],
              [this.state.localeUpperLeft.lng, this.state.localeUpperLeft.lat],
              [this.state.localeUpperLeft.lng, this.state.localeBottomRight.lat],
              [this.state.localeBottomRight.lng, this.state.localeBottomRight.lat]
            ]
          ]
        }
      }]
    };
    this.state.localeRect = {
      bounds:{
        ul:{
          lat: this.state.localeUpperLeft.lat,
          lon: this.state.localeUpperLeft.lng
        },
        br:{
          lat: this.state.localeBottomRight.lat,
          lon: this.state.localeBottomRight.lng
        },
        center:{
          lat: this.state.localeCenter.lat,
          lon: this.state.localeCenter.lng
        }
      }
    };
    this.setState({
      viewState: {
        ...this.state.viewState,
        longitude: this.state.localeCenter.lng,
        latitude: this.state.localeCenter.lat,
        transitionDuration: 1000,
        transitionInterpolator: this.state.flyContainer
      }
    });
    this.onBoundsChanged();
  }

  localeTeleportClicked() {
    let bounds = this.state.localeRect.bounds;
    let position = {
      lat: (bounds.ul.lat + bounds.br.lat) / 2.0,
      lng: (bounds.ul.lon + bounds.br.lon) / 2.0,
    }
    this.mapPanTo(position);
  }

  mapPanTo(position, zoom=13) {
    this.setState({
      viewState: {
        ...this.state.viewState,
        longitude: position.lng,
        latitude: position.lat,
        zoom: zoom,
        transitionDuration: 1000,
        transitionInterpolator: this.state.flyContainer
      }
    });
    this.state.map.zoom = zoom;
    this.onZoomChanged();
    this.updateMapBound(this.state.viewState);
  }

  updateMapState() {
    let zoom = this.state.map.zoom;
    let bounds = this.state.localeRect.bounds;
    let center = {
      lat: bounds.center.lat,
      lng: bounds.center.lon,
    }
    let upperLeft = {
      lat: bounds.ul.lat,
      lng: bounds.ul.lon,
    }
    let bottomRight = {
      lat: bounds.br.lat,
      lng: bounds.br.lon,
    }
    this.setState({
      localeCenter: center,
      zoom: zoom,
      localeUpperLeft: upperLeft,
      localeBottomRight: bottomRight,
    })
    this.state.localeCenter = center;
    this.state.zoom = zoom;
    this.state.localeUpperLeft = upperLeft;
    this.state.localeBottomRight = bottomRight;
  }

  updateMapZoom(zoom){
    if (zoom == this.state.viewState.zoom){
      return;
    }
    let position = {
      lat: this.state.viewState.latitude,
      lng: this.state.viewState.longitude
    };
    this.mapPanTo(position, zoom);
    this.updateMapBound(this.state.viewState);
  }

  updateMapBound(viewState){
    const viewport = new WebMercatorViewport(viewState);
    const ul = viewport.unproject([0, 0]);
    const br = viewport.unproject([this.state.map.screenCoordinates.br.x, this.state.map.screenCoordinates.br.y], false);
    // update map's field here (center...)
    this.state.map.zoom = viewState.zoom;
    this.state.map.center.lon = viewState.longitude;
    this.state.map.center.lat = viewState.latitude;
    this.state.map.bounds.ul.lon = ul[0];
    this.state.map.bounds.ul.lat = ul[1];
    this.state.map.bounds.br.lon = br[0];
    this.state.map.bounds.br.lat = br[1];
  }

  latLonToMeter(lat, lon) {
    let originShift = 2 * Math.PI * 6378137 / 2.0;
    let x = lon * originShift / 180.0;
    let y = Math.log(Math.tan( (90.0 + lat) * Math.PI / 360.0) ) / (Math.PI / 180.0);
    y = y * originShift / 180.0;
    let result = { x: x, y: y };
    return result;
  }

  meterToLatLon(x, y) {
    let originShift = 2 * Math.PI * 6378137 / 2.0;
    let lon = (x / originShift) * 180.0;
    let lat = (y / originShift) * 180.0;
    lat = 180.0 / Math.PI * (2 * Math.atan (Math.exp(lat * Math.PI / 180.0) ) - Math.PI / 2.0);
    let result = { lat: lat, lon: lon };
    return result;
  }

  checkLocaleBoundary() {
    // result 0 = OK, -1 = too small, 1 = too big
    let result = 0;
    let bounds = this.state.localeRect.bounds;
    let zoom = this.state.map.zoom;
    let upperLeft = this.latLonToMeter(bounds.ul.lat, bounds.ul.lon);
    let bottomRight = this.latLonToMeter(bounds.br.lat, bounds.br.lon);
    if (Math.abs(bottomRight.x - upperLeft.x) < MinLocaleMapSize || Math.abs(upperLeft.y - bottomRight.y) < MinLocaleMapSize) {
      result = -1;
    }
    if (Math.abs(bottomRight.x - upperLeft.x) > MaxLocaleMapSize || Math.abs(upperLeft.y - bottomRight.y) > MaxLocaleMapSize) {
      result = 1;
    }
    return result;
  }

  onZoomChanged() {
    let zoom = this.state.map.zoom;
    this.refs.localeDetailMapBar.setState({ zoom: zoom });

    let reminder = "";
    if (zoom < 15){
      reminder = Localization.strings.LOCALE_MAP_ZOOM_LV_REMINDER;
    }
    this.refs.localeDetailMapBar.setState({mapZoomReminder: reminder});
    this.refs.localeDetailMapBar.state.mapZoomReminder = reminder;
  }

  genEditableLayer(){
    const selectedFeatureIndexes = [0];
    const cMode = new CompositeMode([this.state.translateModeContainer, this.state.modifyModeContainer]);
    
    const editableLayer = new EditableGeoJsonLayer({
      id: 'geojson-layer',
      data: this.state.boxData,
      mode: cMode,
      pickingRadius: 10,
      selectedFeatureIndexes,
      _subLayerProps: {
        guides: {
          pointType: 'circle',
          _subLayerProps: {
            'points-circle': {
              // Styling for editHandles goes here
              type: ScatterplotLayer,
              radiusScale: 1,
              stroked: true,
              getLineWidth: 1,
              radiusMinPixels: 4,
              radiusMaxPixels: 8,
              getRadius: 2,
              getFillColor: [220, 10, 0],
              getLineColor: [250, 250, 250],
            },
          },
        },
        geojson: {
          getFillColor: f => {
            var hex = this.state.localeColor;
            while(hex.length != 6){
              hex = '0' + hex;
            }
            hex = hex + '30';
            // convert to RGB
            return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 10];
          },
          getLineColor: f => {
            var hex = this.state.localeColor;
            while(hex.length != 6){
              hex = '0' + hex;
            }
            hex = hex + 'ff';
            // convert to RGB
            return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 255];
          }
        },
      },
      onEdit: ({ updatedData, editType, editContext }) => {
        // if(editType == 'startExtruding' || editType == 'extruded' || editType == 'extruding' || editType == 'translating' || editType == 'translated'){
          if (editType == 'movePosition' || editType == 'finishMovePosition'){
            var selected_index = editContext.positionIndexes[1];
            if (selected_index > 3){
              return;
            }

            /*
            corrected lat lon:
            c2----------c1
            |            |
            |            | ^
            c3----------c0 | lat
                            --> lon
            */

            var corrected_lat_lon = null;

            switch(selected_index){
              case 0: //move c1, c3
                corrected_lat_lon = {
                  c0:{
                    lat: updatedData.features[0].geometry.coordinates[0][0][1],
                    lon: updatedData.features[0].geometry.coordinates[0][0][0]
                  },
                  c1:{
                    lat: updatedData.features[0].geometry.coordinates[0][1][1],
                    lon: updatedData.features[0].geometry.coordinates[0][0][0]
                  },
                  c2:{
                    lat: updatedData.features[0].geometry.coordinates[0][2][1],
                    lon: updatedData.features[0].geometry.coordinates[0][2][0]
                  },
                  c3:{
                    lat: updatedData.features[0].geometry.coordinates[0][0][1],
                    lon: updatedData.features[0].geometry.coordinates[0][3][0]
                  }
                };
                break;

              case 1: //move c0, c2
                corrected_lat_lon = {
                  c0:{
                    lat: updatedData.features[0].geometry.coordinates[0][0][1],
                    lon: updatedData.features[0].geometry.coordinates[0][1][0]
                  },
                  c1:{
                    lat: updatedData.features[0].geometry.coordinates[0][1][1],
                    lon: updatedData.features[0].geometry.coordinates[0][1][0]
                  },
                  c2:{
                    lat: updatedData.features[0].geometry.coordinates[0][1][1],
                    lon: updatedData.features[0].geometry.coordinates[0][2][0]
                  },
                  c3:{
                    lat: updatedData.features[0].geometry.coordinates[0][3][1],
                    lon: updatedData.features[0].geometry.coordinates[0][3][0]
                  }
                };
                break;

              case 2: //move c1, c3
                corrected_lat_lon = {
                  c0:{
                    lat: updatedData.features[0].geometry.coordinates[0][0][1],
                    lon: updatedData.features[0].geometry.coordinates[0][0][0]
                  },
                  c1:{
                    lat: updatedData.features[0].geometry.coordinates[0][2][1],
                    lon: updatedData.features[0].geometry.coordinates[0][1][0]
                  },
                  c2:{
                    lat: updatedData.features[0].geometry.coordinates[0][2][1],
                    lon: updatedData.features[0].geometry.coordinates[0][2][0]
                  },
                  c3:{
                    lat: updatedData.features[0].geometry.coordinates[0][3][1],
                    lon: updatedData.features[0].geometry.coordinates[0][2][0]
                  }
                };
                break;

              case 3: //move c2, c0
                corrected_lat_lon = {
                  c0:{
                    lat: updatedData.features[0].geometry.coordinates[0][3][1],
                    lon: updatedData.features[0].geometry.coordinates[0][0][0]
                  },
                  c1:{
                    lat: updatedData.features[0].geometry.coordinates[0][1][1],
                    lon: updatedData.features[0].geometry.coordinates[0][1][0]
                  },
                  c2:{
                    lat: updatedData.features[0].geometry.coordinates[0][2][1],
                    lon: updatedData.features[0].geometry.coordinates[0][3][0]
                  },
                  c3:{
                    lat: updatedData.features[0].geometry.coordinates[0][3][1],
                    lon: updatedData.features[0].geometry.coordinates[0][3][0]
                  }
                };
                break;
            }

            //reorder c0-c3
            if (editType == 'finishMovePosition'){
              var tmp_corrected_lat_lon = {
                c0:{
                  lat: Math.min(corrected_lat_lon.c0.lat, corrected_lat_lon.c1.lat),
                  lon: Math.max(corrected_lat_lon.c0.lon, corrected_lat_lon.c3.lon)
                },
                c1:{
                  lat: Math.max(corrected_lat_lon.c0.lat, corrected_lat_lon.c1.lat),
                  lon: Math.max(corrected_lat_lon.c0.lon, corrected_lat_lon.c3.lon)
                },
                c2:{
                  lat: Math.max(corrected_lat_lon.c0.lat, corrected_lat_lon.c1.lat),
                  lon: Math.min(corrected_lat_lon.c0.lon, corrected_lat_lon.c3.lon)
                },
                c3:{
                  lat: Math.min(corrected_lat_lon.c0.lat, corrected_lat_lon.c1.lat),
                  lon: Math.min(corrected_lat_lon.c0.lon, corrected_lat_lon.c3.lon)
                }
              };

              corrected_lat_lon = tmp_corrected_lat_lon;
            }

            this.setState({
              boxData: {
                type: "FeatureCollection",
                features:[{
                  type: "Feature",
                  color: null,
                  properties: {},
                  geometry: {
                    type: "Polygon",
                    coordinates: [
                      [
                        [corrected_lat_lon.c0.lon, corrected_lat_lon.c0.lat],
                        [corrected_lat_lon.c1.lon, corrected_lat_lon.c1.lat],
                        [corrected_lat_lon.c2.lon, corrected_lat_lon.c2.lat],
                        [corrected_lat_lon.c3.lon, corrected_lat_lon.c3.lat],
                        [corrected_lat_lon.c0.lon, corrected_lat_lon.c0.lat],
                      ]
                    ]
                  }
                }]
              },
            });

            this.state.localeRect.bounds.ul.lon = corrected_lat_lon.c2.lon;
            this.state.localeRect.bounds.ul.lat = corrected_lat_lon.c2.lat;
            this.state.localeRect.bounds.br.lon = corrected_lat_lon.c0.lon;
            this.state.localeRect.bounds.br.lat = corrected_lat_lon.c0.lat;
            this.state.localeRect.bounds.center.lon = (this.state.localeRect.bounds.ul.lon + this.state.localeRect.bounds.br.lon)/2;
            this.state.localeRect.bounds.center.lat = (this.state.localeRect.bounds.ul.lat + this.state.localeRect.bounds.br.lat)/2;
            this.onBoundsChanged();
          }
        else if (editType == 'translating' || editType == 'translated'){
          this.setState({
            boxData: updatedData
          });
          this.state.localeRect.bounds.ul.lon = updatedData.features[0].geometry.coordinates[0][2][0];
          this.state.localeRect.bounds.ul.lat = updatedData.features[0].geometry.coordinates[0][2][1];
          this.state.localeRect.bounds.br.lon = updatedData.features[0].geometry.coordinates[0][0][0];
          this.state.localeRect.bounds.br.lat = updatedData.features[0].geometry.coordinates[0][0][1];
          this.state.localeRect.bounds.center.lon = (this.state.localeRect.bounds.ul.lon + this.state.localeRect.bounds.br.lon)/2;
          this.state.localeRect.bounds.center.lat = (this.state.localeRect.bounds.ul.lat + this.state.localeRect.bounds.br.lat)/2;
          this.onBoundsChanged();
        }
      }
    });

    return editableLayer;
  }

  genTextLayer(){
    var textData = [];
    var charSet = Localization.strings.TOO_NARROW_REMINDER + Localization.strings.TOO_WIDE_REMINDER + '1234567890. m!!\u2757';

    let coor = this.state.boxData.features[0].geometry.coordinates;

    let upperLeft = this.latLonToMeter(coor[0][2][1], coor[0][2][0]);
    let bottomRight = this.latLonToMeter(coor[0][0][1], coor[0][0][0]);
    let width = parseInt(Math.abs(bottomRight.x - upperLeft.x));
    let height = parseInt(Math.abs(upperLeft.y - bottomRight.y));
    
    // push height data
    textData.push({
      'name': (height>6000 || height<1000)? ' \u2757 ' + height.toString(10) + 'm ' + ((height<1000)?Localization.strings.TOO_NARROW_REMINDER: Localization.strings.TOO_WIDE_REMINDER) + ' ':' ' + height.toString(10) + 'm ',
      'color': (height>6000 || height<1000)? [255, 64, 129]: [255, 255, 255],
      'coordinates': [coor[0][0][0], (coor[0][0][1]+coor[0][2][1])/2],
      'anchor': 'start'
    });
    // push width data
    textData.push({
      'name': (width>6000 || width<1000)? ' \u2757 ' + width.toString(10) + 'm ' + ((width<1000)?Localization.strings.TOO_NARROW_REMINDER: Localization.strings.TOO_WIDE_REMINDER) + ' ':' ' + width.toString(10) + 'm ',
      'color': (width>6000 || width<1000)? [255, 64, 129]: [255, 255, 255],
      'coordinates': [(coor[0][2][0]+coor[0][0][0])/2, coor[0][2][1]],
      'anchor': 'middle'
    });

    var textLayers = new TextLayer({
      id: 'TextLayer',
      data: textData,
      backgroundColor: [63, 51, 181], //cannot use alpha channel
      characterSet: charSet.split(''),
      fontSettings: {
        'fontSize': 100,
      },
      fontWeight: 100,
      getAlignmentBaseline: 'bottom',
      getAngle: 0,
      getColor: d => d.color,
      getPosition: d => d.coordinates,
      getSize: 12,
      getText: d => d.name,
      getTextAnchor: d => d.anchor,
      lineHeight: 1,
      sizeScale: 1,
      pickable: true,
    });

    return textLayers;
  }

  render() {
    let localeDetails = (
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8} sm={2}>
          {Localization.strings.NAME}
        </Grid>
        <Grid item xs={8} sm={10}>
          <TextField value={this.state.localeName} 
          onChange={this.localeNameChanged} 
          inputProps={{ maxLength: Config.MAX_TEXT_LEN().NAME }}
          margin="normal"
          size="small"
          variant="outlined"/>
        </Grid>
        <Grid item xs={8} sm={2}>
          {Localization.strings.DESCRIPTION}
        </Grid>
        <Grid item xs={8} sm={10}>
          <TextField value={this.state.localeDesc} 
          onChange={this.localeDescChanged} 
          multiline inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          margin="normal"
          size="small"
          variant="outlined"/>
        </Grid>
        <Grid item xs={8} sm={2}>
          {Localization.strings.KLA_SHORT}
        </Grid>
        <Grid item xs={8} sm={10}>
          <FormControl>
            <Select
              displayEmpty
              value={this.state.localeKLA}
              onChange={this.localeKLAChanged}
            >
              <MenuItem value={-1} disabled>{Localization.strings.PLEASE_SELECT}</MenuItem>
              {this.props.root.refs.userDataProfile.state.kla.map( (row, i) => {
                return (
                  <MenuItem key={i} value={i}>{row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name']}</MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={8} sm={2}>
          {Localization.strings.SUBJECT}
        </Grid>
        <Grid item xs={8} sm={10}>
          <FormControl>
            <Select
              displayEmpty
              value={this.state.localeSubject}
              onChange={this.localeSubjectChanged}
            >
              <MenuItem value={-1} disabled>{Localization.strings.PLEASE_SELECT}</MenuItem>
              <MenuItem value={0}>{Localization.strings.UNSPECIFIED_SUBJECT}</MenuItem>
              {this.props.root.refs.userDataProfile.state.subject.map( (row, i) => {
                if (this.state.localeKLA > 0 && parseInt(row['kla_id']) === this.state.localeKLA) {
                  return (
                    <MenuItem key={i} value={i+1}>{row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name']}</MenuItem>
                  );
                }
              })}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    );

    const initialViewState = {
      longitude: this.state.localeCenter.lng,
      latitude: this.state.localeCenter.lat,
      zoom: this.state.zoom
    };
    const { viewState, map } = this.state;

    if(Localization.strings.getLanguage() != this.state.map.lang){
      this.state.map.lang = Localization.strings.getLanguage();
      switch(this.state.map._style){
        case "mono":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
              _style: "mono"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
          this.state.map._style = "mono";
          break;
        case "satellite":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
              _style: "satellite"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
          this.state.map._style = "satellite";
          break;
        case "cartoon":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
              _style: "cartoon"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
          this.state.map._style = "cartoon";
          break;
      }
    }

    const editableLayers = this.genEditableLayer();
    const textLayers = this.genTextLayer();

    return (
      <div style={{margin: "12px 0 0 0"}}>
        <Switch condition={this.state.activeView}>
          <Case value={0}>
            {localeDetails}
          </Case>
          <Case value={1}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justify="center"
            >
              <Grid item xs={12} sm={5}>
                <FilePicker
                  root={this.props.root}
                  parent={this}
                  onUploadSuccess={this.onUploadSuccess}
                  onAbortUpload={this.onAbortUpload}
                  allowedExtension="jpg,jpeg,png"
                  pickerTitle={Localization.strings.COVER_IMAGE}
                  fileType="image"
                  fileID={this.state.localeCoverFileID}
                  filePath={this.state.localeCoverFilePath}
                  previewPath={this.state.localeCoverPreviewPath}
                  sizeLimit={10 * oneMB}
                  ref="filePicker"
                />
              </Grid>
            </Grid>
          </Case>
          <Case value={2}>

          {/* <Grid container item xs={12} spacing={3}>
            <Grid item xs={12} sm={4}>
              <Card>
                <CardContent>
                  <Grid item xs={8} sm={2}>
                    {Localization.strings.COLOR}
                  </Grid>
                  <Grid item xs={8} sm={10}>
                    <ExpansionPanel>
                      <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>}>
                        <Icon style={{ color: '#'+this.state.localeColor }}>lens</Icon>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <CirclePicker
                          color={this.state.localeColor}
                          width="100%"
                          circleSize={20}
                          onChange={this.localeColorChanged}
                        />
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Card>
              {Localization.strings.COLOR}
              </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Card>
              {Localization.strings.COLOR}
              </Card>
            </Grid>
          </Grid> */}


            {/* <Grid container spacing={2} alignItems="center">
              <Grid item xs={8} sm={2}>
                {Localization.strings.COLOR}
              </Grid>
              <Grid item xs={8} sm={10}>
                <ExpansionPanel>
                  <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>}>
                    <Icon style={{ color: '#'+this.state.localeColor }}>lens</Icon>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <CirclePicker
                      color={this.state.localeColor}
                      width="100%"
                      circleSize={20}
                      onChange={this.localeColorChanged}
                    />
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Grid>
            </Grid> */}
            <LocaleDetailMapBar root={this.props.root} parent={this} updateMapZoom={this.updateMapZoom} ref="localeDetailMapBar"/>




            <div style={{padding:'8px 0 0 0'}}>
              <div ref={
                    el => {
                      if (!el) return;
                      // console.log(el.getBoundingClientRect());
                      this.state.map.screenCoordinates.ul.x = 0;
                      this.state.map.screenCoordinates.ul.y = 0;
                      this.state.map.screenCoordinates.br.x = el.getBoundingClientRect().width;
                      this.state.map.screenCoordinates.br.y = el.getBoundingClientRect().height;
                    }
                  } style={{position:"relative", height:'57vh'}}>
                <DeckGL 
                  initialViewState={initialViewState} 
                  viewState={viewState}
                  ContextProvider={MapContext.Provider}
                  controller={{
                    doubleClickZoom: false
                  }} 
                  height={this.state.height} 
                  top="50px" position="relative"
                  layers={[editableLayers, textLayers]}  
                  getCursor={editableLayers.getCursor.bind(editableLayers)}
                  ref={this.onRectangleMounted}
                  onViewStateChange={(viewState =>{
                    this.setState({
                      viewState: {
                        ...this.state.viewState,
                        zoom: viewState.viewState.zoom,
                        longitude: viewState.viewState.longitude,
                        latitude: viewState.viewState.latitude,
                        transitionDuration: 0,
                        transitionInterpolator: null
                      }
                    });
                    if(viewState.interactionState.isZooming){
                      this.state.map.zoom = parseInt(viewState.viewState.zoom);
                      this.onZoomChanged();
                    }
                    if (!viewState.interactionState.isDragging && !viewState.interactionState.isRotating || viewState.interactionState.isZooming){
                      this.updateMapBound(viewState.viewState);
                    }
                  })}
                >
                    <StaticMap ref={this.mapRef} mapStyle={map.style} mapboxApiAccessToken={Config.MBOX_KEY()} attributionControl={false}/>
                    <ButtonGroup style={{top:10, left:10, position:"relative"}} size="small" variant="contained" color="primary" aria-label="contained primary button group">
                      <Button color={this.state.map._style=="mono"? "secondary":"primary"} onClick={
                        () => {
                          this.setState({
                            map:{
                              ...this.state.map,
                              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                              _style: "mono"
                            }
                          });
                          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
                          this.state.map._style = "mono";
                        }
                      }>MONO</Button>
                      <Button color={this.state.map._style=="satellite"? "secondary":"primary"} onClick={
                        () => {
                          this.setState({
                            map:{
                              ...this.state.map,
                              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                              _style: "satellite"
                            }
                          });
                          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
                          this.state.map._style = "satellite";
                        }
                      }>SATELLITE</Button>
                      <Button color={this.state.map._style=="cartoon"? "secondary":"primary"} onClick={
                        () => {
                          this.setState({
                            map:{
                              ...this.state.map,
                              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                              _style: "cartoon"
                            }
                          });
                          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
                          this.state.map._style = "cartoon";
                        }
                      }>VECTOR</Button>
                    </ButtonGroup>
                </DeckGL>
              </div>
            </div>
          </Case>
          <Case value={3}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={8} sm={2}>
                {Localization.strings.LANGUAGE}
              </Grid>
              <Grid item xs={8} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.localeLanguage}
                    onChange={this.localeLanguageChanged}
                  >
                    <MenuItem value="tc">繁體中文</MenuItem>
                    <MenuItem value="sc">简体中文</MenuItem>
                    <MenuItem value="en">English</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={8} sm={2}>
                {Localization.strings.SHARABLE}
              </Grid>
              <Grid item xs={8} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.localeShareable}
                    onChange={this.localeShareableChanged}
                  >
                    <MenuItem value={true}>{Localization.strings.PUBLIC}</MenuItem>
                    <MenuItem value={false}>限本校使用</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={8} sm={2}>
                {Localization.strings.PUBLISH}
              </Grid>
              <Grid item xs={8} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.localePublish}
                    onChange={this.localePublishChanged}
                  >
                    <MenuItem value={true}>{Localization.strings.YES}</MenuItem>
                    <MenuItem value={false}>{Localization.strings.NO}</MenuItem>
                  </Select>
                  <FormHelperText>{ this.state.localePublish? "目前為發佈模式，其他人能看見本考察地圖" : "目前為不發佈模式，其他人不能看見本考察地圖" }</FormHelperText>
                </FormControl>
              </Grid>

              <If condition={this.props.root.getMySchoolId() == 3}>
                <Then>
                  <Grid item xs={8} sm={2}>
                    {Localization.strings.USE_REVEAL_CODE}
                  </Grid>
                  <Grid item xs={8} sm={10}>
                    <FormControl>
                      <Select
                        value={this.state.hsRevealCodeEnabled}
                        onChange={this.enableRevealCodeChanged}
                      >
                        <MenuItem value={true}>{Localization.strings.YES}</MenuItem>
                        <MenuItem value={false}>{Localization.strings.NO}</MenuItem>
                      </Select>
                      <FormHelperText>{ this.state.hsRevealCodeEnabled? Localization.strings.ENABLE_REVEAL_CODE_MESSAGE : Localization.strings.DISABLE_REVEAL_CODE_MESSAGE }</FormHelperText>
                    </FormControl>
                  </Grid>
                

                  <If condition={this.state.hsRevealCodeEnabled}>
                    <Then>
                      <Grid item xs={8} sm={2} >
                        {Localization.strings.REVEAL_CODE}
                      </Grid>
                      <Grid item xs={8} sm={10}>
                        <TextField value={this.state.hsRevealCode} 
                          onChange={this.revealCodeChanged} 
                          inputProps={{ maxLength: Config.MAX_TEXT_LEN().REVEAL_CODE }}
                          margin="normal"
                          size="small"
                          variant="outlined"/>
                      </Grid>
                    </Then>
                  </If>
                </Then>
              </If>
              <Grid item xs={8} sm={2}>
                <h6 style={{ color: "red" }}>{Localization.strings.NEW_APP_VERSION_REQUIRED}</h6>
              </Grid>
            </Grid>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default withTheme(LocaleDetailView);